import React from "react";
import Modal from "react-modal";
import { Button, Col } from "react-bootstrap";

import { Warning } from "../../icons/";
import classNames from "classnames/bind";
import "react-slideshow-image/dist/styles.css";
import style from "./index.module.css";
const cx = classNames.bind(style);

interface AleartModelProps {
  isOpen: boolean;
  handleClose: () => void;
  type: "income" | "reset" | "youtube" | null;
  handleCheck: () => void;
}

const AleartModel: React.FC<AleartModelProps> = ({
  isOpen,
  handleClose,
  handleCheck,
  type,
}) => {
  return (
    <Modal
      isOpen={isOpen && type !== null}
      contentLabel=""
      onRequestClose={handleClose}
      className={!!(type === "youtube") ? "ArticleModel" : `AlertModel`}
      overlayClassName="Overlay"
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}>
      <>
        <div className={cx("alertmodelHearder")}>
          <div className={cx("modalTitle")}></div>
          <div className={cx("modalRight")}>
            <button className={cx("modalCloseButton")} onClick={handleClose}>
              <span className={cx("modalCloseButtonFont")}>&times;</span>
            </button>
          </div>
        </div>
        <div className={cx("contentWrap")}>
          <div className={cx("alertmodalContent")}>
            <Col style={{ paddingRight: "10px" }}>
              <Warning />
            </Col>

            {type === "income" && (
              <Col sm={10} style={{ color: "black" }}>
                <div className={cx("mainfont")}>是否入金200,000元？</div>
                <div className={cx("subfont")}>(每日最多可入金一次)</div>
              </Col>
            )}
            {type === "reset" && (
              <Col sm={10} style={{ color: "#CF1A1A" }}>
                <div className={cx("mainfont")}>
                  清除交易紀錄
                  <br />
                  並恢復預設初始資金？
                </div>
              </Col>
            )}
          </div>
        </div>
        <div className={cx("alertmodelFoot")}>
          <div className={cx("button-group")}>
            <Col style={{ display: "inline-grid" }}>
              <Button
                className={cx("alert-button-cancel")}
                onClick={handleCheck}>
                {type === "income" ? "入金" : "清除"}
              </Button>
            </Col>
            <Col style={{ display: "inline-grid" }}>
              <Button className={cx("alert-button")} onClick={handleClose}>
                取消
              </Button>
            </Col>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default AleartModel;
